import { safeParseInt } from '@hawkins/helpers';
import { createStyles, makeStyles } from '@hawkins/styles';
export function toggleButtonGroupStyles(theme) {
    var hawkins = theme.hawkins, hawkinsVariables = theme.hawkinsVariables;
    var borderWidth = safeParseInt(hawkins.ui.borderWidthRegular);
    var isDarkTheme = hawkins.theme === 'dark';
    return createStyles({
        /** Class name of the root element. */
        root: {
            backgroundColor: isDarkTheme ? hawkins.highlight.backgroundColorRegular : hawkins.ui.backgroundColor0,
            borderColor: hawkins.ui.borderColorXlight,
            borderRadius: hawkinsVariables.borderRadius.borderRadius0,
            borderStyle: 'solid',
            borderWidth: borderWidth,
            boxShadow: isDarkTheme ? hawkins.elevation.boxShadow1 : 'none',
            display: 'flex',
            gap: hawkinsVariables.spacings.space0,
            padding: hawkinsVariables.spacingValues.space0 - borderWidth,
        },
    });
}
export var useToggleButtonGroupStyles = makeStyles(toggleButtonGroupStyles, {
    name: 'Hawkins-ToggleButtonGroup',
});
